var map = {
	"./assembly/fullscreen.png": "386f",
	"./assembly/renovate.png": "a3a3",
	"./assembly/select.png": "f2cd",
	"./assembly/tab.png": "cce1",
	"./assembly/time.png": "b3c4",
	"./assembly/weather.png": "5842",
	"./blueTran.png": "efa8",
	"./close.png": "81db",
	"./green.png": "8da3",
	"./greenTran.png": "0380",
	"./kanBanChart/bar.png": "3f39",
	"./kanBanChart/compositeSing.png": "9d07",
	"./kanBanChart/danzhi.png": "56ed",
	"./kanBanChart/liebiao.png": "2dae",
	"./kanBanChart/line.png": "38f7",
	"./kanBanChart/mycaption.png": "4d15",
	"./mask.png": "71db",
	"./moduleWu.png": "7631",
	"./moduleYou.png": "d37d",
	"./qing.png": "b4ec",
	"./qingTran.png": "8cfe",
	"./setting.png": "a0c8",
	"./theme5.png": "e12c",
	"./theme5Tran.png": "4130",
	"./theme6.png": "c55c",
	"./theme6Tran.png": "6146",
	"./theme7.png": "b0ec",
	"./theme7Tran.png": "f908",
	"./theme8.png": "798e",
	"./theme8Tran.png": "af47",
	"./yellowTran.png": "61f1",
	"./图库/example1.png": "eae2",
	"./图库/example2.png": "0ccc",
	"./图库/example3.png": "cbd7b",
	"./图库/example4.png": "7d16",
	"./图库/example5.png": "4857",
	"./图库/example6.png": "ed17",
	"./图库/example7.png": "2f37",
	"./图库/example8.png": "7de5",
	"./图库/progress.png": "01f8",
	"./智慧工业园区.png": "d18b",
	"./白色模块/icon1.png": "0a77",
	"./白色模块/icon2.png": "1ed3",
	"./白色模块/icon3.png": "fa4a",
	"./白色模块/icon4.png": "82fa",
	"./白色模块/icon5.png": "db29",
	"./白色模块/icon6.png": "c86b",
	"./绿色模块/border1.png": "9f9b",
	"./绿色模块/border2.png": "693c",
	"./绿色模块/border3.png": "243a",
	"./绿色模块/border4.png": "da49",
	"./绿色模块/border5.png": "3f2e",
	"./绿色模块/border6.png": "ac33",
	"./绿色模块/borders1.png": "54b6",
	"./绿色模块/borders2.png": "1bae",
	"./绿色模块/borders3.png": "8089",
	"./绿色模块/borders4.png": "2061",
	"./绿色模块/borders5.png": "a15e0",
	"./绿色模块/borders6.png": "de66",
	"./绿色模块/dian1.png": "16b7",
	"./绿色模块/dian2.png": "2e5a",
	"./绿色模块/icon1.png": "5595",
	"./绿色模块/icon2.png": "cf8f",
	"./绿色模块/icon3.png": "b054",
	"./绿色模块/icon4.png": "2856",
	"./绿色模块/icon5.png": "47f8",
	"./绿色模块/icon6.png": "5776",
	"./绿色模块/line3.png": "9396",
	"./绿色模块/line4.png": "6dbd",
	"./绿色模块/pie1.png": "6a45",
	"./绿色模块/pie2.png": "5188",
	"./绿色模块/round.png": "eec7",
	"./自定义/demo1.png": "1981",
	"./自定义/ziicon1.png": "953e",
	"./蓝色模块/border1.png": "e73e",
	"./蓝色模块/border2.png": "fdae",
	"./蓝色模块/border3.png": "b705",
	"./蓝色模块/border4.png": "77f7",
	"./蓝色模块/border5.png": "3ef2",
	"./蓝色模块/border6.png": "4ef2",
	"./蓝色模块/borders1.png": "7241",
	"./蓝色模块/borders2.png": "67e7",
	"./蓝色模块/borders3.png": "8ef1",
	"./蓝色模块/borders4.png": "e6da",
	"./蓝色模块/borders5.png": "f582",
	"./蓝色模块/borders6.png": "4537",
	"./蓝色模块/dian1.png": "7afc",
	"./蓝色模块/dian2.png": "d75b",
	"./蓝色模块/icon1.png": "b958",
	"./蓝色模块/icon2.png": "ebc2",
	"./蓝色模块/icon3.png": "d0cf",
	"./蓝色模块/icon4.png": "5299",
	"./蓝色模块/icon5.png": "7b0a",
	"./蓝色模块/icon6.png": "c5eb",
	"./蓝色模块/line3.png": "b682",
	"./蓝色模块/line4.png": "8336",
	"./蓝色模块/pie1.png": "59ac",
	"./蓝色模块/pie2.png": "21c7",
	"./蓝色模块/round.png": "994a",
	"./金色模块/border1.png": "0699",
	"./金色模块/border2.png": "ab19",
	"./金色模块/border3.png": "4743",
	"./金色模块/border4.png": "d130",
	"./金色模块/border5.png": "561f",
	"./金色模块/border6.png": "53e0",
	"./金色模块/borders1.png": "db8f",
	"./金色模块/borders2.png": "7de4",
	"./金色模块/borders3.png": "a4fa",
	"./金色模块/borders4.png": "f641",
	"./金色模块/borders5.png": "3a44",
	"./金色模块/borders6.png": "9f74",
	"./金色模块/dian1.png": "deb2",
	"./金色模块/dian2.png": "0422",
	"./金色模块/icon1.png": "2899",
	"./金色模块/icon2.png": "5bc3",
	"./金色模块/icon3.png": "b185",
	"./金色模块/icon4.png": "cc3f",
	"./金色模块/icon5.png": "1ae9",
	"./金色模块/icon6.png": "22d1b",
	"./金色模块/line3.png": "8b0c",
	"./金色模块/line4.png": "c5d6",
	"./金色模块/pie1.png": "71b5",
	"./金色模块/pie2.png": "e8f6",
	"./金色模块/round.png": "12c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba4e";